import { useEffect, useState } from 'react';
import { t } from '../i18n';

const API = '/api/taskcenter';

function authHeaders(json = true) {
  const token = localStorage.getItem('token');
  const h = token ? { Authorization: `Token ${token}` } : {};
  if (json) h['Content-Type'] = 'application/json';
  return h;
}

const C = {
  bg: '#FCFCFA', surface: '#fff', border: '#E3E1D9', text: '#2C2C2A',
  muted: '#5F5E5A', primary: '#0F6E56', danger: '#A32D2D', warn: '#C0392B',
};
const card = { background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '0.9rem 1rem', marginBottom: 10 };
const btn = { padding: '7px 14px', fontSize: 13, fontWeight: 600, border: 'none', borderRadius: 8, background: C.primary, color: '#fff', cursor: 'pointer' };
const btnGhost = { ...btn, background: '#fff', color: C.text, border: `0.5px solid ${C.border}` };
const inp = { width: '100%', padding: '8px 10px', fontSize: 13, border: `0.5px solid ${C.border}`, borderRadius: 8, boxSizing: 'border-box', marginBottom: 8 };
const lbl = { fontSize: 12, color: C.muted, display: 'block', marginBottom: 3 };

function toEmbed(url) {
  if (!url) return '';
  let m = url.match(/youtu\.be\/([\w-]+)/) || url.match(/[?&]v=([\w-]+)/);
  if (m) return `https://www.youtube.com/embed/${m[1]}?autoplay=1`;
  return '';
}

function TasksHelpModal({ onClose }) {
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: '1.2rem 1.3rem', maxWidth: 480, maxHeight: '80vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <p style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>💼 How Xpert Tasks works</p>
          <button onClick={onClose} style={{ ...btnGhost, padding: '4px 10px' }}>✕</button>
        </div>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '10px 0 4px' }}>🔍 Earn Pi (workers)</p>
        <p style={{ fontSize: 13, color: C.muted, margin: 0 }}>Browse tab se koi task chunein — like, comment, share, subscribe, signup ya video watch. Task complete kar ke screenshot proof upload karein. Video tasks mein screenshot nahi chahiye: bas video dekhein, timer poora hone par Claim dabayen aur reward foran wallet mein aa jata hai. Screenshot wale tasks creator ke approve karne par pay hote hain — aur agar creator {'{'}72{'}'} ghante mein review na kare to submission khud-ba-khud approve ho jati hai. Reject ghalat lage to Dispute karein, admin faisla karega.</p>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '10px 0 4px' }}>📢 Hire workers (creators)</p>
        <p style={{ fontSize: 13, color: C.muted, margin: 0 }}>My Tasks tab se task banayen — reward per worker aur kitne workers chahiye. Total budget + platform fee ka escrow Pi se pehle jama hota hai, isliye workers ko payment ki guarantee hoti hai. Submissions review karein: sahi proof approve karein (payment automatic), ghalat reject karein (wajah likhna zaroori hai).</p>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '10px 0 4px' }}>💰 Wallet & withdrawal</p>
        <p style={{ fontSize: 13, color: C.muted, margin: 0 }}>Approved rewards aapke Task wallet mein jama hote hain. Minimum threshold poora hone par apne Pi wallet address par withdrawal request bhejein — admin approval ke baad Pi aapko bhej diya jata hai.</p>
      </div>
    </div>
  );
}

function BrowseTab() {
  const [tasks, setTasks] = useState(null);
  const [openTask, setOpenTask] = useState(null);
  const [surveyAns, setSurveyAns] = useState({});
  const [file, setFile] = useState(null);
  const [note, setNote] = useState('');
  const [msg, setMsg] = useState('');
  const [watching, setWatching] = useState(null);
  const [remaining, setRemaining] = useState(0);

  const load = () => fetch(`${API}/tasks/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => setTasks(d.tasks || []));
  useEffect(() => { load(); }, []);

  useEffect(() => {
    if (!watching || remaining <= 0) return;
    const t = setInterval(() => {
      if (document.visibilityState === 'visible') setRemaining((r) => Math.max(r - 1, 0));
    }, 1000);
    return () => clearInterval(t);
  }, [watching, remaining]);

  const startWatch = async (t) => {
    const d = await fetch(`${API}/tasks/${t.id}/start-watch/`, { method: 'POST', headers: authHeaders() }).then((r) => r.json());
    if (d.success) { setWatching(t); setRemaining(d.required_seconds); setMsg(''); }
    else setMsg(d.error || 'Failed');
  };

  const claimWatch = async (t) => {
    const d = await fetch(`${API}/tasks/${t.id}/claim-watch/`, { method: 'POST', headers: authHeaders() }).then((r) => r.json());
    if (d.success) { setMsg(`✅ Verified — ${d.reward} π wallet mein aa gaya!`); setWatching(null); load(); }
    else setMsg(d.error || 'Failed');
  };

  const submit = async (t, answers = null) => {
    if (answers) {
      const res = await fetch(`${API}/tasks/${t.id}/submit/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ survey_answers: answers, note: 'survey' }) });
      const d = await res.json();
      setMsg(d.success || d.id ? 'Submitted!' : (d.error || 'Failed'));
      setOpenTask(null); setSurveyAns({}); load();
      return;
    }
    if (!file) { setMsg(t('tc_ss_req')); return; }
    const fd = new FormData();
    fd.append('screenshot', file);
    fd.append('note', note);
    const res = await fetch(`${API}/tasks/${t.id}/submit/`, { method: 'POST', headers: authHeaders(false), body: fd });
    const d = await res.json();
    if (d.success) { setMsg('✅ Submitted — creator review ke baad Pi wallet mein aa jayega'); setOpenTask(null); setFile(null); setNote(''); load(); }
    else setMsg(d.error || 'Failed');
  };

  if (tasks === null) return <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>;
  if (tasks.length === 0) return <p style={{ fontSize: 13, color: C.muted }}>{t('tc_no_tasks')}</p>;
  return (
    <div>
      {msg && <p style={{ fontSize: 13, color: C.primary }}>{msg}</p>}
      {watching && (
        <div style={{ ...card, borderColor: C.primary }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <p style={{ fontSize: 13, fontWeight: 600, margin: 0 }}>▶️ {watching.title}</p>
            <button style={btnGhost} onClick={() => setWatching(null)}>✕</button>
          </div>
          {toEmbed(watching.link)
            ? <iframe title="task-video" src={toEmbed(watching.link)} style={{ width: '100%', aspectRatio: '16/9', border: 'none', borderRadius: 8, marginTop: 8 }} allow="autoplay; encrypted-media" allowFullScreen />
            : <a href={watching.link} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: C.primary }}>Open video ↗ (is tab pe wapas aa kar timer poora karein)</a>}
          <div style={{ marginTop: 8 }}>
            {remaining > 0
              ? (
                <div>
                  <div style={{ height: 6, background: '#EFEDE6', borderRadius: 3, overflow: 'hidden', marginBottom: 6 }}>
                    <div style={{ height: '100%', width: `${100 - (remaining / watching.required_watch_seconds) * 100}%`, background: C.primary }} />
                  </div>
                  <p style={{ fontSize: 12, color: C.muted, margin: 0 }}>Watch time remaining: {remaining}s (tab kholi rakhein — chhorne pe timer ruk jata hai)</p>
                </div>
              )
              : <button style={btn} onClick={() => claimWatch(watching)}>✅ Claim {watching.reward_per_task} π</button>}
          </div>
        </div>
      )}
      {tasks.map((t) => (
        <div key={t.id} style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
            <div>
              <p style={{ fontSize: 14, fontWeight: 600, margin: '0 0 2px' }}>{t.required_watch_seconds > 0 ? '▶️ ' : ''}{t.title}</p>
              <p style={{ fontSize: 12, color: C.muted, margin: 0 }}>{t.task_type} · by @{t.creator} · {t.slots_left} slots left{t.required_watch_seconds > 0 && ` · ${t.required_watch_seconds}s watch`}</p>
            </div>
            <p style={{ fontSize: 15, fontWeight: 700, color: C.primary, margin: 0, whiteSpace: 'nowrap' }}>{t.reward_per_task} π</p>
          </div>
          {t.instructions && <p style={{ fontSize: 12, color: C.text, margin: '6px 0 0', whiteSpace: 'pre-wrap' }}>{t.instructions}</p>}
          {t.link && t.required_watch_seconds === 0 && <a href={t.link} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: C.primary }}>{t('tc_open_link')} ↗</a>}
          <div style={{ marginTop: 8 }}>
            {t.my_submission_status
              ? <span style={{ fontSize: 12, color: C.muted }}>Your submission: {t.my_submission_status}</span>
              : t.required_watch_seconds > 0
                ? t.slots_left > 0 && <button style={btn} onClick={() => startWatch(t)}>▶ {t('tc_start_watch')}</button>
                : openTask === t.id
                  ? (
                    <div>
                      {t.task_type === 'survey' && (t.survey_questions || []).length > 0 ? (
                        <div>
                          <p style={{ fontSize: 12, color: C.muted, margin: '0 0 6px' }}>{t('sv_survey_note')}</p>
                          {(t.survey_questions || []).map((q, qi) => (
                            <div key={qi} style={{ marginBottom: 10 }}>
                              <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 4px' }}>{qi + 1}. {q.q}</p>
                              {(q.options || []).map((op, oi) => (
                                <label key={oi} style={{ display: 'block', fontSize: 13, margin: '3px 0', cursor: 'pointer' }}>
                                  <input type="radio" name={`q_${t.id}_${qi}`} checked={surveyAns[qi] === oi}
                                    onChange={() => setSurveyAns({ ...surveyAns, [qi]: oi })} style={{ marginRight: 6 }} />
                                  {op}
                                </label>
                              ))}
                            </div>
                          ))}
                          <button style={btn} onClick={() => submit(t, (t.survey_questions || []).map((q, qi) => surveyAns[qi] != null ? (q.options[surveyAns[qi]]) : ''))}>{t('sv_submit_survey')}</button>{' '}
                          <button style={btnGhost} onClick={() => { setOpenTask(null); setSurveyAns({}); }}>{t('tc_cancel')}</button>
                        </div>
                      ) : (
                        <div>
                          <p style={{ fontSize: 12, color: C.muted, margin: '0 0 4px' }}>Proof: {t.proof_instructions}</p>
                          <input type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} style={{ fontSize: 12, marginBottom: 6 }} />
                          <input style={inp} value={note} onChange={(e) => setNote(e.target.value)} placeholder={t('tc_note_ph')} />
                          <button style={btn} onClick={() => submit(t)}>{t('tc_submit_proof')}</button>{' '}
                          <button style={btnGhost} onClick={() => setOpenTask(null)}>{t('tc_cancel')}</button>
                        </div>
                      )}
                    </div>
                  )
                  : t.slots_left > 0 && <button style={btn} onClick={() => { setOpenTask(t.id); setMsg(''); }}>{t('tc_do_task')}</button>}
          </div>
        </div>
      ))}
    </div>
  );
}
function MyWorkTab() {
  const [subs, setSubs] = useState(null);
  const load = () => fetch(`${API}/submissions/mine/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => setSubs(d.submissions || []));
  useEffect(() => { load(); }, []);
  const dispute = async (id) => {
    const note = window.prompt('Dispute reason:') || '';
    await fetch(`${API}/submissions/${id}/dispute/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ note }) });
    load();
  };
  if (subs === null) return <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>;
  if (subs.length === 0) return <p style={{ fontSize: 13, color: C.muted }}>No submissions yet — Browse tab se koi task karein.</p>;
  const color = (s) => (s === 'approved' || s === 'auto_approved' ? C.primary : s === 'rejected' ? C.danger : C.warn);
  return subs.map((s) => (
    <div key={s.id} style={card}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p style={{ fontSize: 13, fontWeight: 600, margin: 0 }}>{s.task_title}</p>
        <span style={{ fontSize: 12, fontWeight: 600, color: color(s.status) }}>{s.status}</span>
      </div>
      <p style={{ fontSize: 12, color: C.muted, margin: '4px 0 0' }}>{s.reward} π · {s.created_at}</p>
      {s.reject_reason && <p style={{ fontSize: 12, color: C.danger, margin: '4px 0 0' }}>Reason: {s.reject_reason}</p>}
      {s.status === 'rejected' && <button style={{ ...btnGhost, marginTop: 6 }} onClick={() => dispute(s.id)}>{t('tc_dispute')}</button>}
    </div>
  ));
}

function MyTasksTab() {
  const [tasks, setTasks] = useState(null);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ title: '', task_type: 'view', link: '', instructions: '', proof_instructions: 'Screenshot of completed task', reward_per_task: '0.1', total_slots: '10', required_watch_seconds: '0', survey_questions: [] });
  const [quote, setQuote] = useState(null);
  const [reviewTask, setReviewTask] = useState(null);
  const [subs, setSubs] = useState([]);
  const [msg, setMsg] = useState('');

  const load = () => fetch(`${API}/tasks/mine/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => setTasks(d.tasks || []));
  useEffect(() => { load(); }, []);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const create = async () => {
    setMsg('');
    const res = await fetch(`${API}/tasks/create/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
    const d = await res.json();
    if (!d.success) { setMsg(d.error || 'Failed'); return; }
    if (d.status === 'active') { setMsg('✅ Task live (super admin — no escrow needed)'); setCreating(false); load(); return; }
    setQuote(d);
  };

  const payEscrow = async () => {
    if (!window.Pi) { setMsg('Pi Browser mein kholein escrow payment ke liye'); return; }
    if (window.xpertPayConfirm && !(await window.xpertPayConfirm({ amount: quote.total_due, memo: 'XpertTasks escrow — workers ki payment guarantee' }))) return;
    await window.Pi.authenticate(['username', 'payments'], () => {});
    window.Pi.createPayment(
      { amount: quote.total_due, memo: `XpertTasks escrow — task #${quote.task_id}`, metadata: { type: 'task_escrow', task_id: quote.task_id } },
      {
        onReadyForServerApproval: (paymentId) => {
          fetch(`${API}/escrow-approve/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ payment_id: paymentId }) });
        },
        onReadyForServerCompletion: (paymentId, txid) => {
          fetch(`${API}/escrow-complete/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ payment_id: paymentId, tx_id: txid, task_id: quote.task_id }) })
            .then((r) => r.json())
            .then((d2) => { if (d2.success) { setMsg('✅ Escrow paid — task is live!'); setQuote(null); setCreating(false); load(); } else setMsg(d2.error || 'Activation failed'); });
        },
        onCancel: () => setMsg('Payment cancelled'),
        onError: () => setMsg('Payment error'),
      }
    );
  };

  const openReview = async (t) => {
    setReviewTask(t);
    const d = await fetch(`${API}/tasks/${t.id}/submissions/`, { headers: authHeaders() }).then((r) => r.json());
    setSubs(d.submissions || []);
  };
  const review = async (id, action) => {
    const body = { action };
    if (action === 'reject') { body.reason = window.prompt('Reject reason (required):') || ''; if (!body.reason) return; }
    await fetch(`${API}/submissions/${id}/review/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(body) });
    openReview(reviewTask); load();
  };

  if (tasks === null) return <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>;
  return (
    <div>
      {msg && <p style={{ fontSize: 13, color: C.primary }}>{msg}</p>}
      {!creating && <button style={{ ...btn, marginBottom: 12 }} onClick={() => { setCreating(true); setQuote(null); }}>➕ {t('tc_create')}</button>}
      {creating && (
        <div style={card}>
          <label style={lbl}>{t('tc_title')}</label>
          <input style={inp} value={form.title} onChange={upd('title')} placeholder="Watch my YouTube video (2 min)" />
          <label style={lbl}>{t('tc_type')}</label>
          <select style={inp} value={form.task_type} onChange={upd('task_type')}>
            <option value="view">{t('tc_view_watch')}</option><option value="like">{t('tc_like')}</option>
            <option value="comment">{t('tc_comment')}</option><option value="share">{t('tc_share')}</option>
            <option value="follow">{t('tc_follow')}</option><option value="signup">{t('tc_signup')}</option>
            <option value="survey">{t('sv_survey')}</option>
            <option value="other">{t('tc_other')}</option>
          </select>
          <label style={lbl}>{t('tc_link')}</label>
          <input style={inp} value={form.link} onChange={upd('link')} placeholder="https://youtube.com/..." />
          <label style={lbl}>{t('tc_instructions')}</label>
          <input style={inp} value={form.instructions} onChange={upd('instructions')} placeholder="Video ko 2 minute dekhein, like karein" />
          <label style={lbl}>{t('tc_proof_req')}</label>
          <input style={inp} value={form.proof_instructions} onChange={upd('proof_instructions')} />
          {form.task_type === 'survey' && (
            <div style={{ border: `0.5px solid ${C.border}`, borderRadius: 8, padding: 10, marginBottom: 10 }}>
              <p style={{ fontSize: 12, fontWeight: 600, margin: '0 0 6px' }}>{t('sv_survey')}</p>
              {(form.survey_questions || []).map((q, qi) => (
                <div key={qi} style={{ background: '#F7F5F0', borderRadius: 6, padding: 8, marginBottom: 6 }}>
                  <input style={inp} value={q.q} placeholder={t('sv_question')}
                    onChange={(e) => { const qs = form.survey_questions.slice(); qs[qi] = { ...qs[qi], q: e.target.value }; setForm({ ...form, survey_questions: qs }); }} />
                  {(q.options || []).map((op, oi) => (
                    <input key={oi} style={{ ...inp, marginLeft: 12, width: 'calc(100% - 12px)' }} value={op} placeholder={`${t('sv_option')} ${oi + 1}`}
                      onChange={(e) => { const qs = form.survey_questions.slice(); const ops = qs[qi].options.slice(); ops[oi] = e.target.value; qs[qi] = { ...qs[qi], options: ops }; setForm({ ...form, survey_questions: qs }); }} />
                  ))}
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button style={{ ...btnGhost, fontSize: 11, padding: '4px 10px' }} onClick={() => { const qs = form.survey_questions.slice(); qs[qi] = { ...qs[qi], options: [...(qs[qi].options || []), ''] }; setForm({ ...form, survey_questions: qs }); }}>+ {t('sv_add_option')}</button>
                    <button style={{ ...btnGhost, fontSize: 11, padding: '4px 10px', color: '#A32D2D' }} onClick={() => { const qs = form.survey_questions.slice(); qs.splice(qi, 1); setForm({ ...form, survey_questions: qs }); }}>✕ {t('sv_remove')}</button>
                  </div>
                </div>
              ))}
              <button style={{ ...btnGhost, fontSize: 12, padding: '5px 12px' }} onClick={() => setForm({ ...form, survey_questions: [...(form.survey_questions || []), { q: '', options: ['', ''] }] })}>➕ {t('sv_add_question')}</button>
            </div>
          )}
          <label style={lbl}>Required watch seconds (video tasks — 0 = screenshot proof)</label>
          <input style={inp} type="number" value={form.required_watch_seconds} onChange={upd('required_watch_seconds')} />
          <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ flex: 1 }}><label style={lbl}>{t('tc_reward')} (π)</label>
              <input style={inp} type="number" step="0.01" value={form.reward_per_task} onChange={upd('reward_per_task')} /></div>
            <div style={{ flex: 1 }}><label style={lbl}>{t('tc_workers')}</label>
              <input style={inp} type="number" value={form.total_slots} onChange={upd('total_slots')} /></div>
          </div>
          {!quote
            ? <><button style={btn} onClick={create}>{t('tc_quote')}</button>{' '}<button style={btnGhost} onClick={() => setCreating(false)}>{t('tc_cancel')}</button></>
            : (
              <div style={{ background: '#F7F5F0', borderRadius: 8, padding: '0.6rem 0.8rem' }}>
                <p style={{ fontSize: 13, margin: '0 0 6px' }}>Escrow: {quote.escrow_total} π + fee {quote.fee} π = <b>{quote.total_due} π</b></p>
                <button style={btn} onClick={payEscrow}>{t('tc_pay_escrow')}</button>
              </div>
            )}
        </div>
      )}
      {tasks.map((t) => (
        <div key={t.id} style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <p style={{ fontSize: 13, fontWeight: 600, margin: 0 }}>{t.title}</p>
            <span style={{ fontSize: 12, color: C.muted }}>{t.status}</span>
          </div>
          <p style={{ fontSize: 12, color: C.muted, margin: '4px 0 6px' }}>{t.approved_count}/{t.total_slots} done · {t.reward_per_task} π each{t.pending_reviews > 0 && <b style={{ color: C.warn }}> · {t.pending_reviews} pending review</b>}</p>
          <button style={btnGhost} onClick={() => openReview(t)}>{t('tc_review_subs')}</button>
        </div>
      ))}
      {reviewTask && (
        <div style={{ ...card, borderColor: C.primary }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <p style={{ fontSize: 13, fontWeight: 600, margin: 0 }}>Submissions — {reviewTask.title}</p>
            <button style={btnGhost} onClick={() => setReviewTask(null)}>✕</button>
          </div>
          {subs.length === 0 && <p style={{ fontSize: 12, color: C.muted }}>{t('tc_no_subs')}</p>}
          {subs.map((s) => (
            <div key={s.id} style={{ borderTop: `0.5px solid ${C.border}`, padding: '8px 0' }}>
              <p style={{ fontSize: 12, margin: '0 0 4px' }}>@{s.worker} · {s.status} · {s.created_at}{s.note && ` · "${s.note}"`}</p>
              {s.screenshot && <a href={s.screenshot} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: C.primary }}>{t('tc_view_ss')} ↗</a>}
              {s.survey_answers && s.survey_answers.length > 0 && (
                <div style={{ background: '#F7F5F0', borderRadius: 6, padding: '6px 8px', margin: '4px 0', fontSize: 12 }}>
                  {s.survey_answers.map((a, qi) => (
                    <div key={qi} style={{ margin: '2px 0' }}>Q{qi + 1}: <b>{String(a)}</b></div>
                  ))}
                </div>
              )}
              {s.status === 'pending' && (
                <div style={{ marginTop: 6 }}>
                  <button style={btn} onClick={() => review(s.id, 'approve')}>✅ {t('tc_approve')}</button>{' '}
                  <button style={{ ...btnGhost, color: C.danger }} onClick={() => review(s.id, 'reject')}>✕ {t('tc_reject')}</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function WalletTab() {
  const [w, setW] = useState(null);
  const [amount, setAmount] = useState('');
  const [address, setAddress] = useState('');
  const [msg, setMsg] = useState('');
  const load = () => fetch(`${API}/wallet/`, { headers: authHeaders() }).then((r) => r.json()).then(setW);
  useEffect(() => { load(); }, []);
  const doWithdraw = async () => {
    setMsg('');
    const res = await fetch(`${API}/withdraw/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ amount, pi_wallet_address: address }) });
    const d = await res.json();
    if (d.success) { setMsg('✅ Withdrawal request submitted — admin approval ke baad Pi bheja jayega'); setAmount(''); load(); }
    else setMsg(d.error || 'Failed');
  };
  if (!w) return <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>;
  return (
    <div>
      <div style={card}>
        <p style={{ fontSize: 24, fontWeight: 700, color: C.primary, margin: 0 }}>{w.balance} π</p>
        <p style={{ fontSize: 12, color: C.muted, margin: '2px 0 0' }}>Total earned: {w.total_earned} π · Min withdrawal: {w.min_withdrawal_pi} π</p>
      </div>
      <div style={card}>
        {msg && <p style={{ fontSize: 13, color: C.primary }}>{msg}</p>}
        <label style={lbl}>{t('tc_amount')} (π)</label>
        <input style={inp} type="number" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} />
        <label style={lbl}>{t('tc_wallet_addr')}</label>
        <input style={inp} value={address} onChange={(e) => setAddress(e.target.value)} placeholder="G..." />
        <button style={btn} onClick={doWithdraw}>{t('tc_req_wd')}</button>
      </div>
      {w.txns.map((t, i) => (
        <p key={i} style={{ fontSize: 12, color: C.muted, margin: '4px 0' }}>{t.created_at} · {t.kind} · {t.amount > 0 ? '+' : ''}{t.amount} π {t.ref && `(${t.ref})`}</p>
      ))}
    </div>
  );
}

function AdminTab() {
  const [s, setS] = useState(null);
  const [disputes, setDisputes] = useState([]);
  const [msg, setMsg] = useState('');
  const load = () => {
    fetch(`${API}/admin-settings/`, { headers: authHeaders() }).then((r) => r.json()).then(setS);
    fetch(`${API}/admin/disputes/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => setDisputes(d.items || []));
  };
  useEffect(() => { load(); }, []);
  const save = async () => {
    const res = await fetch(`${API}/admin-settings/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(s) });
    const d = await res.json();
    if (d.commission_percent !== undefined) { setS(d); setMsg('✅ Settings saved'); } else setMsg(d.error || 'Failed');
  };
  const resolve = async (id, action) => {
    await fetch(`${API}/admin/disputes/${id}/resolve/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ action }) });
    load();
  };
  if (!s) return <p style={{ fontSize: 13, color: C.muted }}>Loading…</p>;
  if (s.error) return <p style={{ fontSize: 13, color: C.danger }}>{s.error}</p>;
  const upd = (k) => (e) => setS({ ...s, [k]: e.target.value });
  return (
    <div>
      <div style={card}>
        <p style={{ fontSize: 14, fontWeight: 600, margin: '0 0 8px' }}>⚙️ {t('tc_settings')}</p>
        {msg && <p style={{ fontSize: 13, color: C.primary }}>{msg}</p>}
        <label style={lbl}>{t('tc_commission')}</label>
        <input style={inp} type="number" step="0.1" value={s.commission_percent} onChange={upd('commission_percent')} />
        <label style={lbl}>{t('tc_min_wd')} (π)</label>
        <input style={inp} type="number" step="0.1" value={s.min_withdrawal_pi} onChange={upd('min_withdrawal_pi')} />
        <label style={lbl}>{t('tc_min_reward')} (π)</label>
        <input style={inp} type="number" step="0.01" value={s.min_reward_per_task} onChange={upd('min_reward_per_task')} />
        <label style={lbl}>{t('tc_auto_hours')}</label>
        <input style={inp} type="number" value={s.auto_approve_hours} onChange={upd('auto_approve_hours')} />
        <label style={lbl}>{t('tc_max_workers')}</label>
        <input style={inp} type="number" value={s.max_slots_per_task} onChange={upd('max_slots_per_task')} />
        <label style={lbl}>{t('tc_listing_fee')} (π)</label>
        <input style={inp} type="number" step="0.1" value={s.campaign_listing_fee_pi} onChange={upd('campaign_listing_fee_pi')} />
        <label style={lbl}>{t('tc_min_pool')} (π)</label>
        <input style={inp} type="number" step="0.1" value={s.campaign_min_pool_pi} onChange={upd('campaign_min_pool_pi')} />
        <button style={btn} onClick={save}>{t('tc_save')}</button>
      </div>
      <div style={card}>
        <p style={{ fontSize: 14, fontWeight: 600, margin: '0 0 8px' }}>⚖️ Disputes ({disputes.length})</p>
        {disputes.length === 0 && <p style={{ fontSize: 12, color: C.muted }}>{t('tc_no_disputes')}</p>}
        {disputes.map((d) => (
          <div key={d.id} style={{ borderTop: `0.5px solid ${C.border}`, padding: '8px 0' }}>
            <p style={{ fontSize: 12, margin: '0 0 2px' }}><b>{d.task_title}</b> — @{d.worker} vs @{d.creator} · {d.reward} π</p>
            <p style={{ fontSize: 12, color: C.danger, margin: '0 0 2px' }}>Creator: {d.reject_reason}</p>
            <p style={{ fontSize: 12, color: C.muted, margin: '0 0 4px' }}>Worker: {d.dispute_note}</p>
            {d.screenshot && <a href={d.screenshot} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: C.primary }}>{t('tc_ss')} ↗</a>}
            <div style={{ marginTop: 4 }}>
              <button style={btn} onClick={() => resolve(d.id, 'approve')}>Worker sahi — pay</button>{' '}
              <button style={{ ...btnGhost, color: C.danger }} onClick={() => resolve(d.id, 'reject')}>Creator sahi — reject</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function TaskCenter({ user }) {
  const [tab, setTab] = useState('browse');
  const [showHelp, setShowHelp] = useState(false);
  const isAdmin = user && (user.is_staff || user.is_superuser || user.username === 'khalidxpert');
  const tabs = [['browse', '🔍 Browse'], ['work', '📋 My work'], ['mytasks', '📢 My tasks'], ['wallet', '💰 Wallet']];
  if (isAdmin) tabs.push(['admin', '⚙️ Admin']);
  if (!localStorage.getItem('token')) return <p style={{ padding: '2rem', fontSize: 14 }}>{t('tc_login')}</p>;
  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif', background: C.bg, minHeight: '100vh' }}>
      {showHelp && <TasksHelpModal onClose={() => setShowHelp(false)} />}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <h1 style={{ fontSize: 22, margin: '0 0 4px' }}>💼 {t('tc_app')}</h1>
        <button onClick={() => setShowHelp(true)} style={{ ...btnGhost, borderRadius: 20, flexShrink: 0 }}>❓ {t('tc_how')}</button>
      </div>
      <p style={{ fontSize: 13, color: C.muted, margin: '0 0 1rem' }}>Complete tasks, earn Pi — ya apne project ke liye workers hire karein.</p>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
        {tabs.map(([k, label]) => (
          <button key={k} onClick={() => setTab(k)} style={{ ...btnGhost, background: tab === k ? C.primary : '#fff', color: tab === k ? '#fff' : C.text }}>{label}</button>
        ))}
      </div>
      {tab === 'browse' && <BrowseTab />}
      {tab === 'work' && <MyWorkTab />}
      {tab === 'mytasks' && <MyTasksTab />}
      {tab === 'wallet' && <WalletTab />}
      {tab === 'admin' && isAdmin && <AdminTab />}
    </div>
  );
}
